import { render, staticRenderFns } from "./goodsManagement.vue?vue&type=template&id=f9c242f6&scoped=true&"
import script from "./goodsManagement.vue?vue&type=script&lang=js&"
export * from "./goodsManagement.vue?vue&type=script&lang=js&"
import style0 from "./goodsManagement.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./goodsManagement.vue?vue&type=style&index=1&id=f9c242f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c242f6",
  null
  
)

component.options.__file = "goodsManagement.vue"
export default component.exports